export default [{
    props: {
        value: {
            required: true
        },
        form: Object,
        path: String,
        label: String,
        helper: String,
        disable: Boolean,
        optional: Boolean,
        hideUnderline: Boolean,
        autofocus: Boolean,
        before: Array,
        after: Array,
        color: {
            type: String,
            default: 'highlight'
        },
        clearable: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            inputValue: this.value
        }
    },

    watch: {
        value(newValue) {
            this.inputValue = newValue
        }
    },

    computed: {
        hasError() {
            if (this.form && this.path && this.form.errors)
                return this.form.errors.has(this.path)
        },

        errorLabel() {
            if (this.form && this.path && this.form.errors && this.form.errors.get(this.path))
                return this.form.errors.get(this.path)
            return ''
        },

        processedLabel() {
            if (this.label)
                return capitalize(this.label) + (this.optional ? ` (${this.$T('optional')})` : '')
        }
    },

    methods: {
        onInput() {
            this.$emit('input', this.inputValue)
            if (this.form && this.path && this.form.errors)
                this.form.errors.clear(this.path)
        }
    }
}]


// WEBPACK FOOTER //
// ./resources/assets/js/components/form/mixins.js